<template>
<div class="home">
    <Navigation></Navigation>
	<HomeBanner></HomeBanner>

	<div class="container mt-5 mb-5 pt-4">
		<div class="main_title mt-5">
			<h2>Reservá tu consulta en 3 simples pasos!</h2>
		</div>
		<div class="row add_bottom_30">
			<div class="col-lg-4">
				<div class="box_feat" id="icon_1">
					<span></span>
					<h3>Elegí tu especialista</h3>
					<p>entre una gran variedad de médicos.</p>
				</div>
			</div>
			<div class="col-lg-4">
				<div class="box_feat" id="icon_2">
					<span></span>
					<h3>Agendá tu hora</h3>
					<p>cuando más te convenga.</p>
				</div>
			</div>
			<div class="col-lg-4">
				<div class="box_feat" id="icon_3">
					<h3>Pagá tu consulta</h3>
					<p>con el medio de pago que prefieras.</p>
				</div>
			</div>
		</div>
		<!-- /row -->
		<div class="text-center">
			<div class="btn_1 medium" v-scroll-to="'#app'" >Buscar Doctor</div>
		</div>

	</div>
	<!-- /container -->

	<HomeMedicRegister></HomeMedicRegister>
	
	<!-- <div class="container">
		<div class="row">
			<div class="col">
				<Advertising></Advertising>
			</div>
		</div>
	</div> -->
	
	<div class="container-fluid panel-donation">
		<div class="container">
			<div class="row ">
				<div class="col-lg-4 text-center">
					<img src="@/assets/img/logo-gratia.png" class="img-fluid" style="max-width:300px">
				</div>

				<div class="col-lg-8">
					<div class="separator d-none  d-lg-block"></div>

					<h3 >Primera Campaña Nacional de Donación de Consultas con Médicos Especialistas.</h3>
					<p >En nuestra determinación por mejorar las condiciones de acceso a la medicina especializada, sentimos la obligación de ir un paso más allá y contribuir para que aquellos de menores recursos también puedan acceder a nuestro servicio.</p>
					<p>
						Por eso creamos esta Campaña de Donación de Consultas y pusimos todo el potencial de nuestra plataforma al servicio de esta iniciativa.
					</p>
					
					<GratiaCodeSearch></GratiaCodeSearch>
				</div>	
			</div>
		</div>
	</div>


	<!-- <div class="container">
		<div class="row">
			<div class="col">
				<Advertising></Advertising>
			</div>
			<div class="col">
				<Advertising></Advertising>
			</div>
		</div>
	</div> -->

	<!-- <HomeTestimonials></HomeTestimonials> -->

	<HomeUserBullets></HomeUserBullets>

	
	<Footer></Footer>

</div>
</template>

<script>
import Navigation from '@/components/Navigation';
import HomeBanner from '@/components/HomeBanner';
import HomeUserBullets from '@/components/HomeUserBullets';
// import HomeTestimonials from '@/components/HomeTestimonials';
import HomeMedicRegister from '@/components/HomeMedicRegister';
import GratiaCodeSearch from '@/components/GratiaCodeSearch';
// import Advertising from '@/components/advertising/Advertising';
import Footer from '@/components/Footer';

export default {
    name: 'home',
	metaInfo: {
		title: 'Reservá tu consulta médica online',
	},
	components: {
		Navigation,
		HomeBanner,
		HomeUserBullets,
		// HomeTestimonials,
		HomeMedicRegister,
		Footer,
		GratiaCodeSearch,
		// Advertising
    },
};
</script>

<style scoped>
.panel-donation{
	padding: 62px 16px;
	background-image:url('../assets/img/bg-gratia.gif');
	background-size: cover;
    background-position: center center;
	align-items: center;
	position:relative;
}
.panel-donation .separator {
	background-color: #7ad6cb;
	width: 2px;
	height: 100%;
	position: absolute;
	top: 0px;
	margin-left:-28px;
	-webkit-box-shadow: 6px 0px 10px 0px rgba(0,0,0,0.14);
	-moz-box-shadow: 6px 0px 10px 0px rgba(0,0,0,0.14);
	box-shadow: 6px 0px 10px 0px rgba(0,0,0,0.14);
}
.panel-donation h3 {
	color: #7ad6cb;

}
</style>

